/**
 * Team Members block — bio modal focus management.
 *
 * The HTML Popover API handles open/close (including Escape and light-dismiss).
 * This module manages focus: moves focus into the modal on open and restores it
 * to the trigger on close.
 */

const FOCUSABLE_SELECTORS = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

function initBioModal(modal) {
  let triggerEl = null;

  modal.addEventListener('toggle', (event) => {
    if (event.newState === 'open') {
      const closeBtn = modal.querySelector('.team-bio-modal__close');
      if (closeBtn) {
        closeBtn.focus();
      }

      modal.addEventListener('keydown', trapFocus);
    } else {
      modal.removeEventListener('keydown', trapFocus);

      if (triggerEl) {
        triggerEl.focus();
        triggerEl = null;
      }
    }
  });

  // Capture the triggering element before the popover opens.
  const id = modal.id;
  if (!id) {
    return;
  }

  document.querySelectorAll(`[popovertarget="${id}"]`).forEach((trigger) => {
    trigger.addEventListener('click', () => {
      triggerEl = trigger;
    });
  });

  function trapFocus(event) {
    if (event.key !== 'Tab') {
      return;
    }

    const focusable = Array.from(modal.querySelectorAll(FOCUSABLE_SELECTORS));
    if (focusable.length === 0) {
      event.preventDefault();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    } else if (document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

document.querySelectorAll('.team-bio-modal').forEach(initBioModal);
